let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("GrTmK")).then(() => parcelRequire('aoTHz'));